import type { AxiosInstance, AxiosPromise, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
import { Configuration } from 'src/generated-api-client';
import { BASE_PATH } from 'src/generated-api-client/base';
import {
    createRequestFunction,
    setOAuthToObject,
    setSearchParams,
    toPathString,
} from 'src/generated-api-client/common';

const DUMMY_BASE_URL = 'https://example.com';

export type Resource = {
    value: string;
    label: string;
};

type GetResourceRequest = {
    resourcePath: string;
    jsonFilter?: string;
};

const BPMSResourcesManagementApiAxiosParamCreator = (
    configuration?: Configuration,
) => {
    return {
        getResource: async (
            requestParameters: GetResourceRequest,
            options?: RawAxiosRequestConfig,
        ) => {
            const localVarPath = `/api/deployment/resource/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(
                `${localVarPath}${requestParameters.resourcePath}`,
                DUMMY_BASE_URL,
            );
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = {
                method: 'GET',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(
                localVarHeaderParameter,
                'bo-portal',
                [],
                configuration,
            );

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(
                localVarHeaderParameter,
                'agent-portal',
                [],
                configuration,
            );

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(
                localVarHeaderParameter,
                'borrower-portal',
                [],
                configuration,
            );

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(
                localVarHeaderParameter,
                'integration-client',
                [],
                configuration,
            );

            if (requestParameters.jsonFilter !== undefined) {
                localVarQueryParameter.jsonFilter =
                    requestParameters.jsonFilter;
            }

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            const headersFromBaseOptions =
                baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options?.headers,
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

const BPMSResourcesManagementApiFp = (configuration?: Configuration) => {
    const localVarAxiosParamCreator =
        BPMSResourcesManagementApiAxiosParamCreator(configuration);

    return {
        getResource: async (
            requestParameters: GetResourceRequest,
            options?: RawAxiosRequestConfig,
        ): Promise<
            (
                axios?: AxiosInstance,
                basePath?: string,
            ) => AxiosPromise<Resource[]>
        > => {
            const localVarAxiosArgs =
                await localVarAxiosParamCreator.getResource(
                    requestParameters,
                    options,
                );

            return (
                axios: AxiosInstance | undefined,
                basePath: string | undefined,
            ) =>
                createRequestFunction(
                    localVarAxiosArgs,
                    globalAxios,
                    BASE_PATH,
                    configuration,
                )(axios, basePath);
        },
    };
};

export const ResourceApiFactory = (
    configuration?: Configuration,
    basePath?: string,
    axios?: AxiosInstance,
) => {
    const localVarFp = BPMSResourcesManagementApiFp(configuration);

    return {
        getResource: (
            requestParameters: GetResourceRequest,
            options?: RawAxiosRequestConfig,
        ) => {
            return localVarFp
                .getResource(requestParameters, options)
                .then((request) => request(axios, basePath));
        },
    };
};
